<app-basic-page [pageTitle]="'Upload Files'" [pageDescription]="'Upload your files'">
  <div class="basic-block">
    <div>
      <nz-upload
        nzType="drag"
        [nzMultiple]="true"
        [nzCustomRequest]="uploadFileHandler"
        (nzChange)="handleChange($event)"
        [nzAccept]="['.pdf']"
      >
        <p class="ant-upload-drag-icon">
          <i nz-icon nzType="inbox"></i>
        </p>
        <p class="ant-upload-text">Click or drag files to this area to upload</p>
        <p class="ant-upload-hint">Only support pdf files.</p>
      </nz-upload>
    </div>
  </div>
</app-basic-page>
